import { memo } from 'react';

import { Switch } from 'antd';
import cn from 'classnames';
import { useDevice } from 'hooks/useDevice';
import { MdDarkMode, MdLightMode } from 'react-icons/md';
import { useAppDispatch, useAppSelector } from 'services/redux/configureStore';
import { switchTheme } from 'services/redux/theme/actions';

import styles from './index.module.css';

export const ThemeSwitcher = memo(function ThemeSwitcher() {
  const dispatch = useAppDispatch();

  const isMobile = useDevice();
  const sidebarMenuCollapsed = useAppSelector((state) => state.navigation.sidebarMenuCollapsed);
  const isDarkMode = useAppSelector((state) => state.theme.isDarkMode);

  return (
    <div
      className={cn(styles.theme, {
        [styles.theme_dark]: isDarkMode,
        [styles.theme_collapsed]: sidebarMenuCollapsed,
        [styles.theme_invisible]: isMobile,
      })}
    >
      <MdLightMode
        className={cn(styles['theme__icon'], { [styles['theme__icon_light']]: !isDarkMode })}
        key={'uniq-icon-1'}
      />
      <Switch
        className={cn(styles['theme-switcher'], {
          [styles['theme-switcher_collapsed']]: sidebarMenuCollapsed,
        })}
        checked={isDarkMode}
        onChange={() => dispatch(switchTheme(!isDarkMode))}
      />
      <MdDarkMode className={cn(styles['theme__icon'], { [styles['theme__icon_dark']]: isDarkMode })} />
    </div>
  );
});
